module.exports = __webpack_public_path__ + "img/m-banner-ugevkzdv-fr-FR.3115b708.jpg";